import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./LoginWithMPIN.scss";
import {
  useLazyGenerateOtpQuery,
  useLazyValidateMpinDataQuery,
} from "../Login_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { updateLoginData, updateScreenTag } from "../Login_Slice";
import CsLocalStorageUtils from "../../../utils/CsLocalStorageUtils";
import { updateLoadingState } from "../../Feature_Loading/Loading_Slice";
import {
  clearCachesOnError,
  generateDeviceID,
  getMobileOperatingSystem,
  handleWebReleaseVersionChange,
} from "../../../utils/helper";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import clevertap from "../../../utils/CleverTap";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { R_HomeRoutes } from "../../../utils/Routes";
import {
  LoginScreenValues,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import { MuiOtpInput } from "mui-one-time-password-input";
import CustomErrorPopup from "../../../pages/AddManuallyPopup/CustomErrorPopup";
import { isEmpty } from "lodash";
import { Colors } from "../../../styles/constant";
import AlertRhombus from "../../../assets/icons/alert-rhombus.svg";
import TriggerGTAEvent from "../../../utils/GTA";
import {
  functionalityCodeForGenerateOtpApi,
  GTAScreenType,
} from "../../../utils/constants";
import MpnLockImg from "../../../assets/images/mpin-lock-4x.png";
import CsSessionStorageUtils from "../../../utils/CsSessionStorageUtils";
import { useLazyGetWebDeploymentVersionQuery } from "../../Feature_GeneralAppElements/GeneralAppElements_Api";
import { saveCsUserId } from "../../../redux-store/reducers/CsAppSlice";

const LoginWithMPIN: React.FC = () => {
  const navigate = useNavigate();
  const [mpin, setMpin] = useState<string>("");
  const [validateMpinApi, mpinApiRes] = useLazyValidateMpinDataQuery();
  const [fetchLatestWebDeploymentVersionApi] =
    useLazyGetWebDeploymentVersionQuery();
  const appDispatch = useAppDispatch();

  const [showErrorPopUp, setShowErrorPopUp] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState<string | undefined>(
    "",
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);

  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOnChangeMpin = (value: string) => {
    setMpin(value);
    if (value.length === 4) {
      validateMpin(value);
    }
  };
  const handleGTMEvent = (ctaText: string) => {
    TriggerGTAEvent("serv_enter_mpin_cta_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "serv_existing_login_mpin_enter_screen",
      isPrevPageNameRequired: true,
      CTA_text: ctaText,
    });
    TriggerGTAEvent("serv_mpin_enter_screen_cta_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "serv_existing_login_mpin_enter_screen",
      isPrevPageNameRequired: true,
      CTA_text: ctaText,
    });
  };

  const forgotMPN = () => {
    handleGTMEvent("forgot_mpin");
    TriggerGTAEvent("serv_login_forgot_mpin_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "serv_existing_login_mpin_enter_screen",
      isPrevPageNameRequired: true,
      CTA_text: "forgot_mpin",
    });
    appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreenForgotmPIN));
  };

  const useOTP = () => {
    handleGTMEvent("use_otp_instead");
    //appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreen));
    generateOtpFun();
  };

  const generateOtpFun = async () => {
    setIsLoading(true);
    const mobileNo = CsLocalStorageUtils.get("MOBILE");
    await generateOtpApi({
      mobileNo: "" + mobileNo,
      otp: "",
      functionality: functionalityCodeForGenerateOtpApi,
      emailRequired: true,
    }).then((res) => {
      setIsLoading(false);
      if (res.isSuccess && res.data?.code === 1) {
        appDispatch(
          updateLoginData({
            key: "mobilenumber",
            value: mobileNo,
          }),
        );
        const tempCsUserId = CsLocalStorageUtils.get("CS_USER_ID");
        if (tempCsUserId) {
          appDispatch(saveCsUserId(tempCsUserId));
        }
        appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreenFormPIN));
      } else if (res.isError && res.error) {
        let newError = res.error as T_ApiResponse<any>;
        if (newError.code && newError.code === 2) {
          setIsLoading(false);
          setShowErrorPopUp(true);
          setShowErrorMessage(newError?.rootCause);
        } else {
          setIsLoading(false);
          appDispatch(
            setError({
              error: res.error as T_ApiResponse<any>,
              message: "failed",
            }),
          );
        }
      }
      appDispatch(updateLoadingState(false));
    });
  };

  const validateMpin = (mpinValue: string) => {
    appDispatch(updateLoadingState(true));

    const mobileNo = CsLocalStorageUtils.get("MOBILE");
    const csUserId = CsLocalStorageUtils.get("CS_USER_ID");
    validateMpinApi({
      csUserId: csUserId,
      mpin: mpinValue || "",
      mobileNo: mobileNo,
      deviceType: getMobileOperatingSystem(),
      deviceId: generateDeviceID(),
    }).then((res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        appDispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));
        CsSessionStorageUtils.set("LOGGED_IN_TIME", new Date().toISOString());
        appDispatch(
          updateLoginData({
            key: "mobilenumber",
            value: mobileNo,
          }),
        );
        if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
          clevertap.onUserLogin.push({
            Site: {
              Identity: csUserId, // String or number
              Phone: "+91" + mobileNo,
            },
          });
        }
        navigate(R_HomeRoutes.home, { replace: true });
      } else if (res.data?.code === API_STATUS_CODE.ERROR) {
        appDispatch(
          setError({
            error: res.data,
            message: "Something went wrong",
          }),
        );
        appDispatch(updateLoadingState(false));
      } else if (res.data?.code === API_STATUS_CODE.BUSINESS_ERROR) {
        setMpin("");
        const mpinContainer = document.querySelector(
          ".MuiOtpInput-TextField-1",
        );
        if (mpinContainer) {
          const inputElement = mpinContainer.querySelector("input");
          if (inputElement) {
            inputElement.focus();
          }
        }
        appDispatch(updateLoadingState(false));
      } else {
        appDispatch(updateLoadingState(false));
      }
    });
  };

  useEffect(() => {
    fetchLatestWebDeploymentVersionApi().then(async (res) => {
      if (
        res.error ||
        res.isError ||
        res.data?.code !== API_STATUS_CODE.SUCCESS
      ) {
        await clearCachesOnError();
      }
      if (!isEmpty(res?.data?.payload)) {
        await handleWebReleaseVersionChange(res?.data?.payload, true);
      }
    });
  }, []);

  return (
    <Box width="100%">
      <Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <img
            src={MpnLockImg}
            style={{ width: "4.8125rem", height: "4.8125rem" }}
          />
        </Box>
        <Typography
          fontWeight={700}
          fontSize={24}
          marginTop="1rem"
          marginBottom=".25rem"
          lineHeight={"1.8rem"}
          align="center"
        >
          {"Welcome to ABC"}
        </Typography>
        <Typography
          fontSize={14}
          marginTop=".25rem"
          fontWeight={400}
          lineHeight={"1.2rem"}
          color={"#979CAE"}
          align="center"
        >
          {"Enter mPIN to log in "}
        </Typography>

        <Box
          display="flex"
          flexDirection="column"
          width="fit-content"
          marginX="auto"
        >
          <MuiOtpInput
            className={`mpin-input `}
            length={4}
            value={mpin}
            onChange={handleOnChangeMpin}
            validateChar={(char) => /^[0-9]$/.test(char)}
            TextFieldsProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
              },
            }}
          />

          {mpinApiRes.data?.code === API_STATUS_CODE.BUSINESS_ERROR && (
            <Box display="flex" alignItems="center">
              <img
                src={AlertRhombus}
                alt="incorrect-otp"
                style={{ marginRight: "0.5rem" }}
              />
              <Typography marginY={"0.5rem"} color={Colors.red} variant="h6">
                {mpinApiRes?.data?.uiDisplayMessage ||
                  "Your mPIN seems wrong. Please try again"}
              </Typography>
            </Box>
          )}
        </Box>

        <Typography
          fontSize={14}
          marginTop="12px"
          fontWeight={500}
          lineHeight={"1.05rem"}
          color={"rgba(199, 34, 42, 1)"}
          align="center"
          onClick={forgotMPN}
          sx={{
            cursor: "pointer",
          }}
        >
          {"Forgot mPIN?"}
        </Typography>
      </Box>
      <Box width="100%">
        {isLoading ? (
          <CustomThreeDotsLoader withText={true} />
        ) : (
          <Button
            fullWidth
            variant="contained"
            className="use-otp-instead-button"
            onClick={useOTP}
          >
            {"Use OTP instead"}
          </Button>
        )}
        {showErrorPopUp && (
          <CustomErrorPopup
            open={showErrorPopUp}
            handleOpen={setShowErrorPopUp}
            errorMessage={showErrorMessage}
          />
        )}
      </Box>
    </Box>
  );
};

export default LoginWithMPIN;
